import api from '../../../api/client'

export async function fetchCustomReportsCatalog() {
  const { data } = await api.get('/reports/custom/catalog')
  return data || { dataSources: [], fields: [], operators: [], visualizations: [], calculationTemplates: [] }
}

export async function previewCustomReport(config, pageSize = 50) {
  const { data } = await api.post('/reports/custom/preview', { config, pageSize })
  return data || {}
}

export async function fetchCustomReports(params = {}) {
  const { data } = await api.get('/reports/custom', { params })
  return Array.isArray(data) ? data : []
}

export async function fetchCustomReportById(reportId) {
  const { data } = await api.get(`/reports/custom/${reportId}`)
  return data || {}
}

export async function createCustomReport(payload) {
  const { data } = await api.post('/reports/custom', payload)
  return data || {}
}

export async function updateCustomReport(reportId, payload) {
  const { data } = await api.put(`/reports/custom/${reportId}`, payload)
  return data || {}
}

export async function deleteCustomReport(reportId) {
  const { data } = await api.delete(`/reports/custom/${reportId}`)
  return data || {}
}

export async function duplicateCustomReport(reportId, newReportName) {
  const { data } = await api.post(`/reports/custom/${reportId}/duplicate`, { newReportName })
  return data || {}
}

export async function runCustomReport(reportId, payload = {}) {
  const { data } = await api.post(`/reports/custom/${reportId}/run`, payload)
  return data || {}
}

export async function exportCustomReport(reportId, format = 'xlsx') {
  const response = await api.post(`/reports/custom/${reportId}/export`, null, {
    params: { format },
    responseType: 'blob',
  })
  const contentDisposition = response.headers?.['content-disposition'] || ''
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
  const filename = filenameMatch?.[1] || `custom-report.${format}`
  return { blob: response.data, filename }
}

export async function exportCustomReportConfig(reportName, config, format = 'xlsx') {
  const response = await api.post(
    '/reports/custom/export-config',
    { reportName, config, format },
    { responseType: 'blob' }
  )
  const contentDisposition = response.headers?.['content-disposition'] || ''
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
  const filename = filenameMatch?.[1] || `${reportName || 'custom-report'}.${format}`
  return { blob: response.data, filename }
}

export async function fetchCustomReportShares(reportId) {
  const { data } = await api.get(`/reports/custom/${reportId}/shares`)
  return Array.isArray(data) ? data : []
}

export async function saveCustomReportShares(reportId, shares) {
  const { data } = await api.post(`/reports/custom/${reportId}/shares`, { shares })
  return data || {}
}
